/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions(value) {
    if (!('AppLinkUrl' in value) || value['AppLinkUrl'] === undefined)
        return false;
    if (!('AppId' in value) || value['AppId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AppLinkUrl': json['AppLinkUrl'],
        'AppId': json['AppId'],
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AppLinkUrl': value['AppLinkUrl'],
        'AppId': value['AppId'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions.js.map